import { Card, CardActionArea, CardContent } from '@mui/material';
import WalletIcon from '@mui/icons-material/Wallet';
import AddIcon from '@mui/icons-material/Add';
import { cx } from '@emotion/css';
import { useGetWalletQuery } from '@/models/wallet';
import { useTranslation } from 'react-i18next';

const iconStyles = 'text-black absolute';

export const Balance = () => {
  const { data } = useGetWalletQuery();
  const { t } = useTranslation();

  const value = data ? parseFloat(data?.balance).toFixed(2) : 0;

  return (
    <Card
      className="group rounded-2xl "
      sx={{
        borderRadius: '1rem',
        border: 'none',
        boxShadow:
          'rgba(145, 158, 171, 0.2) 0px 0px 2px 0px, rgba(145, 158, 171, 0.12) 0px 12px 24px -4px',
        height: '100%',
        width: '100%',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <CardActionArea>
        <CardContent className="flex items-center justify-between">
          <div>
            <div className="text-base">{t('label.balance')}</div>
            <span className="mr-1 text-2xl font-bold text-primary-700">
              {value.toString().length > 6
                ? value.toString().slice(0, 6)
                : value}
            </span>
            <span className="font-bold text-primary-700">
              {t('common.label.pln')}
            </span>
          </div>
          <div className="relative w-8 h-8 transition-all">
            <WalletIcon
              className={cx(iconStyles, 'opacity-20 group-hover:opacity-0')}
              sx={{
                fontSize: '2rem',
              }}
            />
            <AddIcon
              className={cx(iconStyles, 'opacity-0 group-hover:opacity-20')}
              sx={{
                fontSize: '2rem',
              }}
            />
          </div>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};
